import React from "react";
import styled from "styled-components";

const ExternalLinksContainer = styled.div`
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background-color: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
`;

const ExternalLinksTitle = styled.h4`
  font-size: 14px;
  margin-bottom: 0.5rem;
  color: #374151;
`;

const ExternalLink = styled.a`
  display: block;
  font-size: 12px;
  color: #3b82f6;
  text-decoration: none;
  margin-bottom: 0.25rem;
  
  &:hover {
    text-decoration: underline;
  }
`;

const ExternalLinks = ({ name, t }) => {
  const getLinks = (parameterName) => {
    switch (parameterName) {
      case "Klimat":
        return [
          { url: "https://www.ri.se/sv", text: t("RISE - Research Institutes of Sweden") },
          { url: "https://www.fao.org", text: t("FAO - Food and Agriculture Organization") }
        ];
      case "Vatten":
        return [
          { url: "https://waterfootprint.org", text: t("Water Footprint Network") }
        ];
      case "Social rättvisa":
        return [
          { url: "https://www.bertelsmann-stiftung.de", text: t("Bertelsmann Stiftung") }
        ];
      case "Biologisk mångfald":
        return [
          { url: "https://epi.yale.edu", text: t("Environmental Performance Index") }
        ];
      case "Djurvälfärd":
        return [
          { url: "https://www.worldanimalprotection.org", text: t("World Animal Protection") }
        ];
      case "Arbetsförhållanden":
      case "Lokalbefolkning":
        return [
          { url: "https://www.amfori.org", text: t("Amfori") }
        ];
      default:
        return [];
    }
  };

  const links = getLinks(name);

  if (links.length === 0) return null;

  return (
    <ExternalLinksContainer>
      <ExternalLinksTitle>{t("Källa")}</ExternalLinksTitle>
      {links.map((link, index) => (
        <ExternalLink key={index} href={link.url} target="_blank" rel="noopener noreferrer">
          {link.text}
        </ExternalLink>
      ))}
    </ExternalLinksContainer>
  );
};

export default ExternalLinks;
